export type DatePeriod = [null|string, null|string];

export function parseDatePeriod(value: string): DatePeriod {
    const period: unknown = JSON.parse(value);

    if (!Array.isArray(period) || period.length !== 2) {
        throw new Error("The persisted date period is invalid.");
    }

    if (period.some(date => date !== null && typeof date !== "string")) {
        throw new Error("The persisted date period contains an invalid date.");
    }

    return period as DatePeriod;
}
